import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.21278 10.5573C9.21112 10.5547 9.20946 10.5521 9.2078 10.5496L11.0668 8.69061L9.57995 2H1V3C1 6.99781 2.17402 10.7245 4.1964 13.8503C4.42099 14.1975 4.65604 14.5372 4.90111 14.8691L9.21278 10.5573Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.59425 21.0045L21.0039 1.59437L20.9996 1.59007L21.0037 1.58594L22.418 3.00013L11.8349 13.5834C12.3428 14.0236 12.8826 14.4279 13.4504 14.7922L15.3094 12.9332L22 14.4201V23H21C17.0022 23 13.2755 21.826 10.1497 19.8036C9.24131 19.2159 8.38369 18.5566 7.58477 17.8337L3.00418 22.4144L1.59425 21.0045Z"}}]};

const CallOffFilled = Vue.extend<IconProps>({
  name: 'CallOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'call-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CallOffFilled;
